import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-225" data-mp="o71jkm7hsj9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-226" data-mp="j7yej1riid1b">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-forest-900 sm:text-4xl" data-id="element-227" data-mp="j53tp94l6q7d">
          Everything included
        </h2>
        <p className="mt-3 text-center text-muted" data-id="element-228" data-mp="1bvkt152a322y">
          {productShortName} · {totalVolumes} volumes + {totalBonuses} bonuses ·{' '}
          <b className="text-forest-800" data-id="element-229" data-mp="16uy65pkzucr3">{price}</b>
        </p>

        <ul className="mt-10 grid overflow-hidden rounded-xl border border-earth-200 bg-white sm:grid-cols-2" data-id="element-230" data-mp="12u4gaqnzqnvk">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 border-b border-earth-100 p-4 sm:odd:border-r" data-id="element-231" data-mp="3nleq2uex7umn">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest-800" data-id="element-232" data-mp="3icwe6rrq1wk5">
                <CheckIcon className="h-3.5 w-3.5 text-gold-400" aria-hidden="true" data-id="element-233" data-mp="3ncir103n1asf" />
              </span>
              <p data-id="element-234" data-mp="39czkgbqh67i8">
                <b className="block text-sm text-forest-900" data-id="element-235" data-mp="39bg6irsak8jm">{feature}</b>
                <span className="text-sm text-muted" data-id="element-236" data-mp="3dd1q0vzbzl2s">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-earth-500 bg-earth-100 px-6 py-5 text-center font-display text-lg font-bold leading-relaxed text-earth-700" data-id="element-237" data-mp="2zlmw3u3vxzgy">
          “The best time to have these materials was at the start of your year. The second-best time is today.”
        </blockquote>
      </div>
    </section>;
}